import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Tooltip,
  TabPane,
  CardTitle,
} from "reactstrap";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import classnames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import Select from "react-select";
import Config from "config";
const FormWizard = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  //meta title
  document.title = "DOM COM | Nouvel investisseur";
  const token = localStorage.getItem("auth_token_" + api);
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // Nom, prénom, date de naissance, ville de naissance, département de naissance, profession
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [villeNaissance, setVilleNaissance] = useState("");
  const [depNaissance, setDepNaissance] = useState("");
  const [profession, setProfession] = useState("");
  const [adresseFiscale, setAdresseFiscale] = useState("");
  const [complementAdresse, setComplementAdresse] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");
  const [emailPersonnel, setEmailPersonnel] = useState("");
  const [emailProfessionel, setEmailProfessionel] = useState("");
  const [telephoneFixe, setTelephoneFixe] = useState("");
  const [telephoneMobile, setTelephoneMobile] = useState("");
  const smartCapitalizeWithDash = (word, originalWord) => {
    return word
      .split("-")
      .map((subWord, subIndex) => {
        const originalSubWord = originalWord.split("-")[subIndex] || "";

        // Préserve les majuscules existantes
        return subWord
          .split("")
          .map((char, charIndex) => {
            const originalChar = originalSubWord[charIndex];
            if (originalChar && originalChar === originalChar.toUpperCase()) {
              return char.toUpperCase();
            }
            return charIndex === 0 ? char.toUpperCase() : char.toLowerCase();
          })
          .join("");
      })
      .join("-");
  };

  const handleParenthesis = (word, originalWord) => {
    // Gérer les parenthèses comme "Casablanca (Maroc)"
    if (word.includes("(") && word.includes(")")) {
      const mainPart = word.substring(0, word.indexOf("(")).trim();
      const parenthesisPart = word.substring(
        word.indexOf("(") + 1,
        word.indexOf(")")
      );
      const afterParenthesis = word.substring(word.indexOf(")") + 1);

      // Parties originales pour préserver majuscules
      const originalMainPart = originalWord
        .substring(0, originalWord.indexOf("("))
        .trim();
      const originalParenthesisPart = originalWord.substring(
        originalWord.indexOf("(") + 1,
        originalWord.indexOf(")")
      );

      const capitalizedMain = smartCapitalizeWithDash(
        mainPart,
        originalMainPart
      );
      const capitalizedParenthesis = smartCapitalizeWithDash(
        parenthesisPart,
        originalParenthesisPart
      );

      return `${capitalizedMain} (${capitalizedParenthesis})${afterParenthesis}`;
    }
    return smartCapitalizeWithDash(word, originalWord);
  };
  const handleVilleNaissanceChange = (e) => {
    const rawValue = e.target.value;

    // Utilise une regex pour capitaliser chaque mot
    const transformedValue = rawValue.toLowerCase().replace(/\b\w/g, (char) => {
      return char.toUpperCase();
    });

    console.log(transformedValue);
    setVilleNaissance(transformedValue);
  };

  /*************************   TITRE *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [titre, setTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTitre();
        await getSituationMatrimoniale();
        await getPay();
        await getPartenaire();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  /*************************   Pays  *******************************/
  const [pay, setPay] = useState("");
  const [payData, setPayData] = useState({ data: [] });
  const renderPayOptions = () => {
    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePayChange = (e) => {
    setPay(e);
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/

  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [situationMatrimoniale, setSituationMatrimoniale] = useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  /*************************   Partenaire  *******************************/
  const [partenaireData, setPartenaireData] = useState({
    data: [],
  });

  const [partenaire, setPartenaire] = useState("");

  const renderPartenaireOptions = () => {
    return [
      {
        options: partenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePartenaireChange = (e) => {
    setPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/partenaires`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((partenaireCollection) => {
          setPartenaireData(partenaireCollection);
          // si partenaireData contient qu'un seul element, on set le partenaire
          console.log(partenaireCollection);
          console.log(partenaireCollection.data.length);
          if (partenaireCollection.data.length === 1) {
            setPartenaire(partenaireCollection.data[0]);
          }
          console.log(partenaire);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/investisseurs/send_new_invest`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            nom: nom,
            prenom: prenom,
            titre_id: titre?.value || "",
            date_de_naissance: dateNaissance,
            ville_de_naissance: villeNaissance,
            departement_ou_pays: depNaissance,
            profession: profession,
            situation_matrimoniale_id: situationMatrimoniale?.value || "",
            partenaire_id: partenaire?.value || partenaire?.id || "",
            pay_id: pay?.value || "",
            adresse_fiscale: adresseFiscale,
            complement_adresse: complementAdresse,
            code_postal: codePostal,
            ville: ville,
            email_perso: emailPersonnel,
            // email_professionel: emailProfessionel,
            // tel_fixe: telephoneFixe,
            tel_mob: telephoneMobile,
          }),
        }
      );
      if (response.ok) {
        console.log("POST request successful");
        const responseData = await response.json();
        toast.success(responseData?.message);
        navigate(`${backUrl}/investisseurs/${responseData?.investisseur_id}`);
        setLoading(false);
      } else {
        console.error("POST request failed");
        const responseData = await response.json();
        if (responseData && responseData.error) {
          toast.error(responseData.error);
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row className="mb-2">
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-4 card-title flex-grow-1"
                      style={{ fontWeight: "bold" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Investisseurs
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i> Nouvel investisseur
                    </h5>
                  </div>
                  {loading ? (
                    <Spinners setLoading={setLoading} setWait={400} />
                  ) : (
                    <>
                      <div className="wizard clearfix">
                        <div className=" clearfix">
                          <Card>
                            <TabPane tabId={1}>
                              <Form>
                                <>
                                  <Row className="mb-2">
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          {" "}
                                          Coordonnées personnelles
                                        </CardTitle>
                                        <CardBody>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Partenaire :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={partenaire}
                                                onChange={
                                                  handlePartenaireChange
                                                }
                                                options={renderPartenaireOptions()}
                                                isClearable={true}
                                                className="select2"
                                                isSearchable={false}
                                                placeholder="Partenaire"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Titre :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                value={titre}
                                                onChange={handleTitreChange}
                                                options={renderTitreOptions()}
                                                isClearable={true}
                                                className="select2"
                                                isSearchable={false}
                                                placeholder="Titre"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Nom :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                style={{
                                                  textTransform: "uppercase",
                                                }}
                                                defaultValue={nom}
                                                required
                                                onChange={(e) =>
                                                  setNom(
                                                    e.target.value.toUpperCase()
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Prénom :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                style={{
                                                  textTransform: "capitalize",
                                                }}
                                                defaultValue={prenom}
                                                onChange={(e) =>
                                                  setPrenom(
                                                    e.target.value
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                      e.target.value
                                                        .slice(1)
                                                        .toLowerCase()
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>

                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Date de naissance :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={dateNaissance}
                                                className="form-control input-color"
                                                onChange={(dateString) => {
                                                  setDateNaissance(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>
                                                  Ville de naissance :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                value={villeNaissance}
                                                required
                                                onChange={
                                                  handleVilleNaissanceChange
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>
                                                  Code département de naissance
                                                  <i
                                                    className="bx bx-info-circle"
                                                    style={{
                                                      marginLeft: "5px",
                                                      cursor: "pointer",
                                                      color: "black",
                                                      fontSize: "15px",
                                                    }}
                                                    id="CodeDepartementNaissance"
                                                    onMouseEnter={toggleTooltip}
                                                    onMouseLeave={toggleTooltip}
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipOpen}
                                                    target="CodeDepartementNaissance"
                                                    toggle={toggleTooltip}
                                                  >
                                                    Saisir le numéro du
                                                    département pour la France
                                                    et le pays en toutes lettres
                                                    lorsque l’investisseur est
                                                    né hors de France.
                                                  </Tooltip>{" "}
                                                  :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                defaultValue={depNaissance}
                                                required
                                                onChange={(e) =>
                                                  setDepNaissance(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Adresse
                                        </CardTitle>
                                        <CardBody>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>
                                                  Adresse résidence fiscale :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                required
                                                onChange={(e) =>
                                                  setAdresseFiscale(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>
                                                  Complément adresse :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                required
                                                onChange={(e) =>
                                                  setComplementAdresse(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Code postal :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                required
                                                onChange={(e) =>
                                                  setCodePostal(e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Ville :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                value={ville}
                                                required
                                                onChange={(e) =>
                                                  setVille(
                                                    e.target.value.toUpperCase()
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Pays :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                onChange={handlePayChange}
                                                options={renderPayOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Coordonnées de contact
                                        </CardTitle>
                                        <CardBody>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>E-mail personnel :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                required
                                                onChange={(e) =>
                                                  setEmailPersonnel(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          {/*                                           <Row className="mb-2">

                                          <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  
                                                >
                                                  E-mail professionnel :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              className="col-md-6"
                                            >
                                              <input
                                                className="form-control form-control-sm"
                                                required
                                                onChange={(e) =>
                                                  setEmailProfessionel(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row> */}
                                          {/* <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Téléphone fixe :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                required
                                                onChange={(e) =>
                                                  setTelephoneFixe(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Téléphone mobile :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                required
                                                onChange={(e) =>
                                                  setTelephoneMobile(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Renseignements Divers
                                        </CardTitle>
                                        <CardBody>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>Profession :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                defaultValue={profession}
                                                required
                                                onChange={(e) =>
                                                  setProfession(e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="mb-2">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>
                                                  Situation matrimoniale :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                value={situationMatrimoniale}
                                                onChange={
                                                  handleSituationMatrimonialeChange
                                                }
                                                options={renderSituationMatrimonialeOptions()}
                                                isClearable={true}
                                                className="select2"
                                                isSearchable={false}
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                </>
                              </Form>
                            </TabPane>
                          </Card>
                        </div>
                        <div className="actions clearfix">
                          <ul>
                            <li>
                              <button
                                className="btn btn-info"
                                onClick={handleSubmit} // validation PP
                              >
                                Créer
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default FormWizard;
